export function repeatString(str: string, times: number): string {
    return new Array(times + 1).join(str);
}
